import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchTypes from '../FormElements/searchTypeRadioButtons/SearchTypes';
import BankruptcyForm from './BankruptcyForm';
import CivilForm from './CivilForm';
import AppellateForm from './AppellateForm';
import { Loading } from '../../common/Loading';
import Receipt from '../../Modules/Receipt/Receipt';
import NoResults from '../../common/NoResults';
import { resetLocalCourtSearch } from '../../../redux/actions/localCourtSearchAction';
import LocalCourtResults from './LocalCourtResults';

const searchForms = {
  Bankruptcy: BankruptcyForm,
  Civil: CivilForm,
  Criminal: CivilForm,
  Appellate: AppellateForm,
};

export class LocalCourtSearch extends Component {
  static displayName = 'LocalCourtSearch';

  constructor(props) {
    super(props);

    this.state = {
      selectedSearchType: 'Bankruptcy',
    };
  }

  handleChangeSearchType = (selectedSearchType) => {
    this.setState({ selectedSearchType });
    this.props.onResetSearch();
  };

  render() {
    const { selectedSearchType } = this.state;
    const SearchForm = searchForms[selectedSearchType];
    const { searchResultsType, isLoading, receipts, searchType, data } = this.props;

    return (
      <section className="filings-form">
        <SearchTypes
          listOfSearchTypes={Object.keys(searchForms)}
          changeSearchType={this.handleChangeSearchType}
          selectedSearchType={selectedSearchType}
        />

        <SearchForm {...this.props} />

        <Loading show={isLoading} />

        {searchResultsType &&
          <div className="ir-search-items">
            {searchResultsType === 'empty'
              ? <NoResults />
              : <LocalCourtResults {...{ data, searchResultsType, searchType }} />
            }

            {receipts.map((receipt, idx) => <Receipt key={idx}>{receipt}</Receipt>)}
          </div>
        }
      </section>
    );
  }
}

LocalCourtSearch.propTypes = {
  searchResultsType: PropTypes.string,
  isLoading: PropTypes.bool,
  receipts: PropTypes.any,
  onResetSearch: PropTypes.func.isRequired,
  data: PropTypes.any,
  searchType: PropTypes.string,
};

LocalCourtSearch.defaultProps = {
  searchResultsType: null,
  isLoading: false,
  receipts: [],
  data: [],
  searchType: '',
};

const mapStateToProps = state => ({ ...state.get('localCourtSearch').toJS() });

const mapDispatchToProps = {
  onResetSearch: resetLocalCourtSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocalCourtSearch);



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/LocalCourtSearch.jsx